import { useEffect, useState } from "react";
import { Lock, CreditCard, X } from "@phosphor-icons/react";
import { useNavigate } from "react-router-dom";

let _paywallSetter = null;

/** Global helper — call to open the paywall (used by axios interceptor when a 402/trial_expired lands). */
export function openPaywall(reason = "trial_expired") {
  if (_paywallSetter) _paywallSetter({ open: true, reason });
}

/** Sticks near the top of the AdminShell so admins always know the trial window. */
export function PaywallModal() {
  const [state, setState] = useState({ open: false, reason: "" });
  const nav = useNavigate();

  useEffect(() => {
    _paywallSetter = setState;
    return () => { _paywallSetter = null; };
  }, []);

  if (!state.open) return null;

  return (
    <div className="fixed inset-0 z-[120] flex items-center justify-center bg-black/70 backdrop-blur-sm p-4" data-testid="paywall-modal">
      <div className="relative bg-white max-w-md w-full rounded-2xl border-2 border-[#0f172a] shadow-2xl overflow-hidden">
        <div className="bg-gradient-to-br from-red-600 via-red-500 to-amber-500 text-white px-6 py-5">
          <div className="flex items-center justify-between">
            <div className="inline-flex items-center gap-2">
              <Lock weight="fill" size={22}/>
              <span className="font-black uppercase tracking-widest text-xs">Trial Ended</span>
            </div>
            <button onClick={() => setState({ open: false, reason: "" })} data-testid="paywall-close-btn"
              className="p-1 hover:bg-white/20 rounded-lg">
              <X weight="bold" size={20}/>
            </button>
          </div>
          <h2 className="mt-3 font-display font-black text-2xl leading-tight">
            Add a payment method to keep Field Radar running.
          </h2>
          <p className="mt-2 text-sm text-white/90 font-medium">
            Your 7-day trial has ended. You can still view your data, but new jobs, edits, and imports are paused until you subscribe.
          </p>
        </div>
        <div className="p-6 space-y-3">
          <button
            onClick={() => { setState({ open: false, reason: "" }); nav("/admin/branding"); }}
            data-testid="paywall-subscribe-btn"
            className="w-full h-12 bg-[#00C4CC] hover:bg-[#00b0b6] text-white font-black uppercase tracking-widest text-sm inline-flex items-center justify-center gap-2 rounded-xl transition">
            <CreditCard weight="bold" size={18}/> Subscribe Now
          </button>
          <button
            onClick={() => setState({ open: false, reason: "" })}
            data-testid="paywall-later-btn"
            className="w-full h-11 border-2 border-slate-300 text-slate-700 font-bold uppercase tracking-wider text-xs rounded-xl hover:bg-slate-50">
            Not Now (Read-Only Mode)
          </button>
        </div>
      </div>
    </div>
  );
}
